module.exports = __webpack_public_path__ + "static/media/ikon_fyrlykt.92f4456a.svg";